<template>
  <USelectMenu
    v-model="selected"
    v-model:open="isOpen"
    data-testid="page-language-select"
    :items="languages"
    :placeholder="placeholder"
    :ui="{
      base: selectBaseClass,
      value: 'text-[1rem]',
    }"
    @update:open="handleOpenChange"
  >
    <template #item="{ item: country }">
      <img
        v-if="isOpen && getFlagUrl(country)"
        :src="getFlagUrl(country)"
        alt=""
        class="h-4 w-6 rounded-xs object-cover"
        aria-hidden="true"
      />
      <span
        :data-testid="`page-language-option-${getIso6391Code(country)}`"
        class="truncate font-mainFont text-sm text-primary-600"
        >{{ getLanguageOwnName(getIso6393Code(country)) }}</span
      >
    </template>
    <template #trailing>
      <AppIcon
        v-show="hovered"
        name="i-heroicons-chevron-down-20-solid"
        class="transition-transform duration-300"
        :size="22"
      />
    </template>
  </USelectMenu>
</template>

<script>
import {
  getFlagUrl,
  getLanguageName,
  getIso6391Code,
  getIso6393Code,
  getLanguageOwnName,
} from '~/components/Utilities/languages/languages.js'
import { supportedLocales } from '~~/locales/supported-locales'
export default {
  props: {
    hovered: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['dropdownOpen', 'dropdownClose'],
  data() {
    return {
      languages: [],
      isOpen: false,
      placeholder: this.getLanguageName(this.$i18n.locale),
      selected: this.getLanguageName(this.$i18n.locale),
    }
  },
  computed: {
    selectBaseClass() {
      return [
        'w-full relative block flex justify-start pl-0 font-mainFont cursor-pointer',
        this.hovered ? 'text-primary-600' : 'text-transparent',
      ].join(' ')
    },
  },
  watch: {
    selected(newVal) {
      this.$i18n.locale = getIso6391Code(newVal)
      localStorage.setItem('selectedLanguage', getIso6391Code(newVal))
      window.location.reload()
    },
  },
  created() {
    this.languages = supportedLocales.map((lang) => this.getLanguageName(lang))
    this.placeholder = this.getLanguageName(this.$i18n.locale)
  },
  methods: {
    handleOpenChange(open) {
      this.isOpen = open
      if (open) {
        this.$emit('dropdownOpen')
      } else {
        this.$emit('dropdownClose')
      }
    },
    getFlagUrl(languageCode) {
      return getFlagUrl(languageCode)
    },
    getLanguageName(languageCode) {
      return getLanguageName(languageCode)
    },
    getIso6391Code(languageCode) {
      return getIso6391Code(languageCode)
    },
    getIso6393Code(languageCode) {
      return getIso6393Code(languageCode)
    },
    getLanguageOwnName(languageCode) {
      return getLanguageOwnName(languageCode)
    },
  },
}
</script>
